import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedNetwork: "",
  selectedVideos: [],
};

const top5Slice = createSlice({
  name: "top5",
  initialState,
  reducers: {
    setSelectedNetwork: (state, action) => {
      state.selectedNetwork = action.payload;
    },
    setSelectedVideos: (state, action) => {
      state.selectedVideos = action.payload;
    },
    addVideoToTop5: (state, action) => {
      if (
        !state.selectedVideos.some((v) => v.id === action.payload.id)
      ) {
        state.selectedVideos.push(action.payload);
      }
    },
    removeVideoFromTop5: (state, action) => {
      state.selectedVideos = state.selectedVideos.filter(
        (v) => v.id !== action.payload
      );
    },
    resetTop5State: (state) => {
      state.selectedNetwork = "";
      state.selectedVideos = [];
    },
  },
});

export const {
  setSelectedNetwork,
  setSelectedVideos,
  addVideoToTop5,
  removeVideoFromTop5,
  resetTop5State,
} = top5Slice.actions;

export default top5Slice.reducer;
